// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageButton_wrapper__cyhAP","wrapperDisabled":"ImageButton_wrapperDisabled__mbg-Y","icon":"ImageButton_icon__PR5e0","iconDisabled":"ImageButton_iconDisabled__4wcml"};